export default "__VITE_ASSET__CumeXQJM__"